import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { capitalize } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { AccountControl } from '../../components/LoginControl/components/AccountControl.js';
import { useAuthentication } from '../../hooks/useAuthentication/index.js';
export const LoginControl = ({
  hideLabelBreakpoint,
  onLoginClick,
  onLogoutClick
}) => {
  const {
    toggleWidget,
    isLoggedIn,
    profileData,
    doLogout,
    getProfileData
  } = useAuthentication();
  const [profileFetched, setProfileFetched] = useState(false);
  useEffect(() => {
    if (isLoggedIn && !profileFetched) {
      setProfileFetched(true);
      getProfileData();
    }
  }, [getProfileData, isLoggedIn, profileFetched]);
  const username = useMemo(() => {
    if (isLoggedIn && profileData?.firstName) {
      const firstName = capitalize(profileData.firstName);
      const lastName = capitalize(profileData.lastName);
      return `${firstName[0]}. ${lastName}`;
    }
    return null;
  }, [isLoggedIn, profileData?.firstName, profileData?.lastName]);
  const handleLoginClick = () => {
    if (isLoggedIn) return;
    toggleWidget('signIn');
    onLoginClick?.();
  };
  const handleLogoutClick = () => {
    doLogout();
    onLogoutClick?.();
  };
  return _jsx(AccountControl, {
    hideLabelBreakpoint: hideLabelBreakpoint,
    username: username,
    isLoggedIn: isLoggedIn,
    onLogoutClick: handleLogoutClick,
    onLoginClick: handleLoginClick
  });
};